// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container_1PL-U","logo":"index_logo_1Vp0C","logoAnimate":"index_logoAnimate_gGiI_","mainLogo":"index_mainLogo_xXWHA","version":"index_version_1q20l"};